import { groq } from 'next-sanity'
import cmsSettings from '../cmsSettings'
import { basicProductFields } from '@/data/sanity/fragments/_shared'
import { fields as productCategoryFields } from '@/data/sanity/fragments/productCategory'
export const fields = groq`
  _type,
  _id,
  ${cmsSettings()},
  products[]->{${basicProductFields}},
  filters[]->{${productCategoryFields}}
`

export const fragment = (name = 'productGallery') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
